import {Injectable} from '@angular/core';
import {Logger} from '../../utils/Logger';
import {PortfolioService} from '../../service/portfolio.service';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class SelectedManualInvestmentsGuard implements CanActivate {
    private readonly portfolioService: PortfolioService;

    constructor(portfolioService: PortfolioService) {
        this.portfolioService = portfolioService;
    }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const tempPortfolioId = route.params.tempPortfolioId;
        const manualInvestPortfolioCreationData = await this.portfolioService.getLocalPortfolioCreationData(tempPortfolioId);
        if (manualInvestPortfolioCreationData.portfolioAmount) {
            return true;
        } else {
            Logger.log(`Could not find any selected investments. Not allowing user to enter the page.`);
            return false;
        }
    }
}
